module.exports = __webpack_public_path__ + "static/media/just-cut.a7597202.svg";